import api from './api';

const eventsService = {
  async getAll(page = 1, limit = 10) {
    const response = await api.get('/events', { params: { page, limit } });
    return response.data;
  },

  async getOne(id) {
    const response = await api.get(`/events/${id}`);
    return response.data;
  },

  async create(data) {
    const response = await api.post('/events', data);
    return response.data;
  },

  async update(id, data) {
    const response = await api.patch(`/events/${id}`, data);
    return response.data;
  },

  async remove(id) {
    const response = await api.delete(`/events/${id}`);
    return response.data;
  },

  async getRegistrations(id) {
    const response = await api.get(`/events/${id}/registrations`);
    return response.data;
  },
};

export default eventsService;
